// extracted by mini-css-extract-plugin
module.exports = {"webSolutions":"styles-module--webSolutions--2NmqA","container":"styles-module--container--2qvZ5","text":"styles-module--text--35Pq8"};